// src/components/VitalsCard.js
import React, { useState, useEffect } from "react";

import HeartRate from "../assets/vitals/Heartrate.svg";
import BP from "../assets/vitals/Bp.svg";
import ECG from "../assets/vitals/Ecg.svg";
import HeartSound from "../assets/vitals/heartsound.svg";

import SPO2 from "../assets/vitals/spo2.svg";
import LungSound from "../assets/vitals/lungsound.svg";

import HRV from "../assets/vitals/HRV.svg";
import Steps from "../assets/vitals/steps.svg";
import Sleep from "../assets/vitals/sleep.svg";
import Improve from "../assets/vitals/improve.svg";
import { formatSleep } from "../utils/format";

import ArrowDown from "../assets/vitals/arrow-down.svg";
import ArrowUp from "../assets/vitals/arrow-up.svg";

import "../styles/vital.css";

export default function VitalsCard({ selectedTab, data }) {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    setOpenIndex(null); // close accordion when user switches tab
  }, [selectedTab]);

  const metrics = data?.health_metrics || {};
  const vitals = data?.vitals_dashboard || {};

  // ==========================
  // 🔴 DYNAMIC VITALS MAPPING
  // ==========================
  const vitalsData = {
    heart: [
      {
        label: "Heart Rate",
        value: `${metrics?.heart_rate?.value ?? "--"} bpm`,
        status: metrics?.heart_rate?.label ?? "N/A",
        desc: vitals?.heart_rate?.summary ?? "No summary available.",
        icon: HeartRate,
      },
      {
        label: "Blood Pressure",
        value: `${metrics?.bp?.systolic ?? "--"}/${metrics?.bp?.diastolic ?? "--"} mmHg`,
        status: metrics?.bp?.label ?? "N/A",
        desc: vitals?.blood_pressure?.summary ?? "No summary available.",
        icon: BP,
      },
      {
        label: "ECG Interpretation",
        value: metrics?.ecg?.score ?? "No Data",
        status: metrics?.ecg?.label ?? "N/A",
        desc: "ECG uploaded from admin portal. Currently no automated interpretation available.",
        icon: ECG,
      },
      {
        label: "Heart Sound",
        value: metrics?.heart_sound?.score ?? "No Data",
        status: metrics?.heart_sound?.label ?? "N/A",
        desc: `Heart sound confidence: ${metrics?.heart_sound?.confidence ?? "--"}`,
        icon: HeartSound,
      },
    ],

    lung: [
      {
        label: "Oxygen Level (SpO₂)",
        value: `${metrics?.spo2?.value ?? "--"} %`,
        status: metrics?.spo2?.label ?? "N/A",
        desc: vitals?.spo2?.summary ?? "No summary available.",
        icon: SPO2,
      },
      {
        label: "Lung Sound",
        value: metrics?.lung_sound?.score ?? "No Data",
        status: metrics?.lung_sound?.label ?? "N/A",
        desc: `Lung sound confidence: ${metrics?.lung_sound?.confidence ?? "--"}`,
        icon: LungSound,
      },
    ],

    body: [
      {
        label: "BMI",
        value: metrics?.bmi?.value ?? "--",
        status: metrics?.bmi?.label ?? "N/A",
        desc: `BMI score: ${metrics?.bmi?.score ?? "--"}`,
        icon: HeartRate,
      },
      {
        label: "Steps",
        value: `${metrics?.steps_data?.value ?? metrics?.steps_data ?? "--"} steps`,
        status: "N/A",
        desc: vitals?.steps?.summary ?? "Daily steps information.",
        icon: Steps,
      },
      {
        label: "Sleep Duration",
        value: metrics?.sleep_data
          ? formatSleep(metrics.sleep_data)
          : "--",
        status: "N/A",
        desc: vitals?.sleep?.summary ?? "Sleep tracking data.",
        icon: Sleep,
      },
      {
        label: "HRV",
        value: metrics?.hrv ?? "No Data",
        status: "N/A",
        desc: "Heart rate variability data.",
        icon: HRV,
      },
    ]
  };
  console.log("Steps summary:", vitals?.steps?.summary);
  console.log("Sleep summary:", vitals?.sleep?.summary);
  console.log("BMI:", metrics?.bmi);
  console.log("Selected Tab:", selectedTab);
  console.log("Body metrics:", metrics?.steps_data);
  console.log("Body sleep:", metrics?.sleep_data);

  const activeVitals = vitalsData[selectedTab] || [];

  return (
    <div className="vitals-card">
      <div className="vitals-column">
        <div className="vitals-scroll-container">

          {activeVitals.map((item, index) => {
            const opened = openIndex === index;

            return (
              <div className="vital-card accordion-card" key={index}>
                
                {/* HEADER */}
                <div
                  className="vital-header"
                  role="button"
                  //onClick={() => setOpenIndex(opened ? null : index)}
                >
                  <div className="vh-left">
                    <img src={item.icon} alt="" className="vital-icon" />

                    <div>
                      <h4 className="vital-title">{item.label}</h4>
                      <p className="vital-value">{item.value}</p>
                    </div>
                  </div>

                  <div className="vh-right">
                    <span
                      className={
                        item.status?.toLowerCase() === "normal"
                          ? "status normal"
                          : "status abnormal"
                      }
                    >
                      {item.status}
                    </span>

                    {/* <img
                      src={opened ? ArrowUp : ArrowDown}
                      alt="toggle"
                      className="accordion-arrow-icon"
                    /> */}
                  </div>
                </div>

                {/* CONTENT */}
                <div className={`accordion-content ${opened ? "open" : ""}`}>
                  <div className="accordion-inner">
                    <div className="accordion-title-row">
                      <img src={Improve} alt="" className="desc-icon" />
                      <h5 className="desc-title">{item.label}</h5>
                    </div>

                    <p className="desc-text">{item.desc}</p>
                  </div>
                </div>

              </div>
            );
          })}

        </div>
      </div>
    </div>
  );
}
